var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.00053C7.0245 8.00053 5.7985 7.68103 5 7.14453C5 7.51753 5 7.76353 5 8.00053C5 8.82903 6.567 9.50053 8.5 9.50053C10.433 9.50053 12 8.82903 12 8.00053C12 7.76353 12 7.51753 12 7.14453C11.2015 7.68103 9.9755 8.00053 8.5 8.00053Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5005C7.0245 10.5005 5.7985 10.181 5 9.64453C5 10.0175 5 10.2635 5 10.5005C5 11.329 6.567 12.0005 8.5 12.0005C10.433 12.0005 12 11.329 12 10.5005C12 10.2635 12 10.0175 12 9.64453C11.2015 10.181 9.9755 10.5005 8.5 10.5005Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7C10.433 7 12 6.32843 12 5.5C12 4.67157 10.433 4 8.5 4C6.567 4 5 4.67157 5 5.5C5 6.32843 6.567 7 8.5 7Z",
    fill: "#525252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3C5.433 3 7 2.32843 7 1.5C7 0.671573 5.433 0 3.5 0C1.567 0 0 0.671573 0 1.5C0 2.32843 1.567 3 3.5 3Z",
    fill: "#525252"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.98703C3.8365 8.99503 3.6705 9.00053 3.5 9.00053C2.0245 9.00053 0.7985 8.68103 0 8.14453C0 8.51753 0 8.76353 0 9.00053C0 9.82903 1.567 10.5005 3.5 10.5005C3.67 10.5005 3.8365 10.4935 4 10.4835V8.98703Z",
    fill: "#525252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.48703C3.8365 6.49503 3.6705 6.50053 3.5 6.50053C2.0245 6.50053 0.7985 6.18103 0 5.64453C0 6.01753 0 6.26353 0 6.50053C0 7.32903 1.567 8.00053 3.5 8.00053C3.67 8.00053 3.8365 7.99353 4 7.98353V6.48703Z",
    fill: "#525252"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96 3.88353C4.509 3.95853 4.021 4.00053 3.5 4.00053C2.0245 4.00053 0.7985 3.68103 0 3.14453C0 3.51753 0 3.76353 0 4.00053C0 4.82903 1.567 5.50053 3.5 5.50053C3.6705 5.50053 3.837 5.49353 4.0015 5.48353C4.0075 4.85203 4.355 4.30353 4.96 3.88353Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.30db70741828662278eb76a84c1de663.svg";
export { ForwardRef as ReactComponent };